import React, { useEffect, useState } from "react";

const Notification = ({ type, message, closeNotification }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (message) {
      setVisible(true);

      const timer = setTimeout(() => {
        setVisible(false);
        setTimeout(closeNotification, 300);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [message, closeNotification]);

  return (
    <div
      className={`font-main z-10 fixed bottom-4 right-4 w-[25rem] mb-11 p-4 rounded shadow-lg transform transition-all duration-300 ease-in-out ${
        visible
          ? "font-main translate-y-0 opacity-100"
          : "font-main translate-y-8 opacity-0 pointer-events-none"
      } ${
        type === "success"
          ? "font-main bg-gradient-to-r from-green-100 to-green-200 border-green-400"
          : "font-main bg-gradient-to-r from-red-100 to-red-200 border-red-400"
      }`}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <div
            className={`flex items-center justify-center w-6 h-6 rounded-full ${
              type === "success" ? "bg-green-500" : "bg-red-500"
            } mr-3`}
          >
            {type === "success" ? (
              <svg
                className="w-2 h-2 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            ) : (
              <svg
                className="w-5 h-5 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            )}
          </div>
          <p className="text-xs  font-main">{message}</p>
        </div>
        <button
          onClick={() => {
            setVisible(false);
            setTimeout(closeNotification, 300);
          }}
          className="text-gray-400 hover:text-gray-600 focus:outline-none"
        >
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Notification;
